import React, { useEffect, useState } from 'react';
import { Container, Paper, Typography, Box, Button, CircularProgress, Alert } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import api from '../../services/api';

const VerifyFunderPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [status, setStatus] = useState('verifying'); // verifying, success, error
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('Invalid verification link.');
            return;
        }

        const verify = async () => {
            try {
                await api.post('/auth/verify-funder', { token });
                setStatus('success');
            } catch (error) {
                setStatus('error');
                setMessage(error.response?.data?.message || 'Verification failed. The link may have expired.');
            }
        };

        verify();
    }, [token]);

    return (
        <Container maxWidth="sm" sx={{ mt: 8 }}>
            <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                
                {status === 'verifying' && (
                    <Box>
                        <CircularProgress sx={{ mb: 2 }} />
                        <Typography variant="h6">Verifying your account...</Typography>
                    </Box>
                )}

                {status === 'success' && (
                    <Box>
                        <CheckCircleIcon color="success" sx={{ fontSize: 60, mb: 2 }} />
                        <Typography variant="h5" gutterBottom>Account Verified!</Typography>
                        <Typography color="text.secondary" paragraph>
                            Your funder account is now active. You can log in to start managing your bursary programs.
                        </Typography>
                        <Button variant="contained" onClick={() => navigate('/login')}>
                            Go to Login
                        </Button>
                    </Box>
                )}

                {status === 'error' && (
                    <Box>
                        <ErrorIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
                        <Typography variant="h5" gutterBottom>Verification Failed</Typography>
                        <Alert severity="error" sx={{ mb: 3 }}>{message}</Alert>
                        <Button variant="outlined" onClick={() => navigate('/contact')}>
                            Contact Support
                        </Button>
                    </Box>
                )}

            </Paper>
        </Container>
    );
};

export default VerifyFunderPage;